var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"number"},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('div',[_vm._l((_vm.value.toString().split('')),function(res,index){return [_c('span',{key:index,staticClass:"num"},[_vm._v(_vm._s(res))])]})],2),_c('span',[_vm._v(_vm._s(_vm.unit))])])
}
var staticRenderFns = []

export { render, staticRenderFns }